import { callAct, isOk } from './apiConfig';

/*
 * businessIntl — the business's international settings (בינלאומי): currency / timezone /
 * default language. Backed by the business row (currency, timezone, defaultLocale columns) via
 * the getBusinessIntl / updateBusinessIntl acts. Both acts are AUTHENTICATED and scoped
 * server-side to the session business, so a business can only ever read/write its OWN settings.
 * The server STRICTLY whitelists every value — the client cannot write an arbitrary currency /
 * timezone / locale. Mirrors businessConfig's transport (callAct/isOk) and never throws.
 */

// Safe defaults mirror the DB column defaults, so nothing breaks if the act isn't reachable.
export const INTL_DEFAULTS = {
    currency: 'ILS',
    timezone: '',
    defaultLocale: 'he',
};

// Normalize a raw row → the fields the app reads (with defaults).
function normalize(row) {
    const out = { ...INTL_DEFAULTS };
    if (row && typeof row === 'object') {
        if (row.currency) out.currency = String(row.currency);
        if (row.timezone != null) out.timezone = String(row.timezone);
        if (row.defaultLocale) out.defaultLocale = String(row.defaultLocale);
    }
    return out;
}

// Load the business's international settings. Returns the normalized values (defaults on error —
// never throws).
export async function getIntl() {
    try {
        const envelope = await callAct('getBusinessIntl', {});
        if (isOk(envelope) && envelope.data) return normalize(envelope.data);
    } catch (e) { /* act not available */ }
    return { ...INTL_DEFAULTS };
}

// Save the international settings. Returns { ok, intl }. intl is the fresh server values on success.
export async function saveIntl({ currency, timezone, defaultLocale } = {}) {
    try {
        const payload = {
            currency: currency != null ? String(currency) : INTL_DEFAULTS.currency,
            timezone: timezone != null ? String(timezone) : INTL_DEFAULTS.timezone,
            defaultLocale: defaultLocale != null ? String(defaultLocale) : INTL_DEFAULTS.defaultLocale,
        };
        const envelope = await callAct('updateBusinessIntl', payload);
        return { ok: isOk(envelope), intl: isOk(envelope) ? normalize(envelope.data) : null };
    } catch (e) { return { ok: false }; }
}

export default { getIntl, saveIntl, INTL_DEFAULTS };
